import {AnchorNav, Box} from '@primer/react-brand'
import {analyticsEvent} from '../../../../lib/analytics'
import {PricingCards} from './PricingCards'
import {PricingTable} from './PricingTable'

interface PricingAltSectionProps {
  sectionPricingRef: React.RefObject<HTMLElement>
  siteCopilotPurchaseRefresh: boolean
  copilotSignupPath: string
  copilotForBusinessSignupPath: string
  copilotForBusinessSignupPathRefresh: string
  copilotEnterpriseSignupPath: string
  copilotContactSalesPath: string
  pricingExperience: string
}

export default function PricingAltSection({
  sectionPricingRef,
  siteCopilotPurchaseRefresh,
  copilotSignupPath,
  copilotForBusinessSignupPath,
  copilotForBusinessSignupPathRefresh,
  copilotEnterpriseSignupPath,
  copilotContactSalesPath,
  pricingExperience,
}: PricingAltSectionProps) {
  return (
    <>
      <section
        id="pricing-2"
        className="lp-Section lp-Section--new-pricing-experience lp-Section--pricing"
        ref={sectionPricingRef}
      >
        <PricingCards
          siteCopilotPurchaseRefresh={siteCopilotPurchaseRefresh}
          copilotSignupPath={copilotSignupPath}
          copilotForBusinessSignupPath={copilotForBusinessSignupPath}
          copilotForBusinessSignupPathRefresh={copilotForBusinessSignupPathRefresh}
          copilotEnterpriseSignupPath={copilotEnterpriseSignupPath}
          copilotContactSalesPath={copilotContactSalesPath}
          pricingExperience={pricingExperience}
        />
      </section>
      <section className="lp-Section lp-Section--new-pricing-experience-table pt-0 pb-5">
        <details>
          <summary>
            <div style={{position: 'relative'}}>
              <span className="icon-collapsed pr-3" />
              <span className="icon-expanded pr-3" />
            </div>
            <h3>Compare all features</h3>
          </summary>
          <PricingTable
            copilotSignupPath={copilotSignupPath}
            copilotForBusinessSignupPath={copilotForBusinessSignupPath}
            copilotContactSalesPath={copilotContactSalesPath}
          />
        </details>
      </section>
      <Box style={{height: 0}}>
        <AnchorNav hideUntilSticky>
          <AnchorNav.Link
            href="#enterprise"
            {...analyticsEvent({action: 'enterprise_grade', tag: 'link', context: 'sticky', location: 'subnav'})}
          >
            Enterprise-grade
          </AnchorNav.Link>
          <AnchorNav.Link
            href="#features"
            {...analyticsEvent({action: 'features', tag: 'link', context: 'sticky', location: 'subnav'})}
          >
            Features
          </AnchorNav.Link>
          <AnchorNav.Link
            href="#faq"
            {...analyticsEvent({action: 'faqs', tag: 'link', context: 'sticky', location: 'subnav'})}
          >
            FAQs
          </AnchorNav.Link>
          <AnchorNav.Action
            href="#pricing"
            {...analyticsEvent({action: 'pricing', tag: 'link', context: 'sticky', location: 'subnav'})}
          >
            Get started with Copilot
          </AnchorNav.Action>
          <AnchorNav.SecondaryAction href="#" hidden />
        </AnchorNav>
      </Box>
    </>
  )
}

try{ PricingAltSection.displayName ||= 'PricingAltSection' } catch {}